import { useTranslation } from "react-i18next";
import React from "react";

const AboutFeatures = () => {
  const { t } = useTranslation("about");
  return (
    <section className="padding-x md-max:px-6 md-max:py-10 flex justify-between gap-10 md-max:flex-col md-max:gap-4">
      <div className="w-1/2 md-max:w-full">
        <div className="h-full bg-[#CAE5FB] w-full rounded-3xl object-cover p-20 md-max:px-4 md-max:py-10 md-max:gap-5 flex flex-col gap-14">
          <h2 className="text-[#1C75BC] text-5xl md-max:text-3xl font-semibold flex items-end gap-3 relative">
            <hr className="w-2.5 h-20 md-max:h-10 md-max:w-1.5 bg-[#1c75bc]" />
            {t("mission.title")}
            <img src="/our-mission-icon.png" alt="mission" className="absolute -top-10 left-5 scale-75 md-max:scale-50 md-max:-top-12 md-max:left-0" />
          </h2>
          <p className="text-[#1c75bc] text-2xl md-max:text-sm flex gap-7 md-max:gap-4">
          <hr className="w-2 md-max:w-1 h-full bg-[#1c75bc]" />
            {t("mission.text1")}
            <br /><br />
            {t("mission.text2")}
            <br /><br />
            {t("mission.text3")}
          </p>
        </div>
      </div>
      <div className="flex w-1/2 flex-col gap-5 md-max:w-full md-max:gap-4">
        {t("mission.cards", { returnObjects: true }).map((feature) => (
          <div
            key={feature.id}
            style={{ background: feature.color }}
            className="flex flex-col gap-1 justify-center rounded-3xl h-full px-10 !py-18 md-max:py-10"
          >
            <h3 className="max-w-[90%] text-white text-5xl font-semibold md-max:text-3xl uppercase">
              {feature.title}
            </h3>
            <p className="max-w-3/4 text-[#FFF1E8]">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AboutFeatures;
